import Navbar from "../navbar";
import Brand from "../brand";

const Header = () => {
    return (
        <header className="z-[999] transition-all text-text fixed top-0 left-0 w-full custom-screen py-4 flex items-center justify-center md:justify-between">
            <Brand />
            <Navbar />
            <a
                href="/#heim"
                className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 bg-primary text-bg px-4 py-2 rounded"
            >
                Zum Hauptinhalt springen
            </a>
        </header>
    );
};

export default Header;
